import Vue from 'vue'
import { attachCordovaDeeplinkListener, runOidcBootstrap } from '@/plugins/rhAuth/oidc-bootstrap'

Vue.config.productionTip = false

runOidcBootstrap()
attachCordovaDeeplinkListener()
